export default function () {
    return {
        randomSeed: null,
        profile: {},
        surveyFinalized: false,
        notifications: {},
        oauthAcls: [],
        AMCache: {},
    };
}
